import React from 'react';

import { ButtonVariant } from '../ButtonV3/types';
import { ButtonV3 } from '../ButtonV3';
import ModalV2, { ModalV2Props } from '../Modal/ModalV2';
import H from '../../typography/Headings';
import P from '../../typography/Paragraphs';

import styles from './sharedModalStyles.module.less';

export enum SaveProgressModalTypes {
  DEFAULT = 'DEFAULT',
  REMOVE = 'REMOVE',
}

const COPIES: {
  [modalType in keyof typeof SaveProgressModalTypes]: {
    dek: string;
    secondaryCta: string;
    secondaryCtaVariant: ButtonVariant;
  };
} = {
  DEFAULT: {
    dek: 'Create a free account to save your design',
    secondaryCta: 'No, thanks',
    secondaryCtaVariant: 'secondary',
  },
  REMOVE: {
    dek: "You're so close—removing this item will permanently delete it",
    secondaryCta: 'Delete my draft',
    secondaryCtaVariant: 'tertiary',
  },
};

type SaveProgressModalProps = {
  modalType?: SaveProgressModalTypes;
  onClickPrimaryCta: () => void;
  onClickSecondaryCta: () => void;
} & Omit<ModalV2Props, 'dialogHeadingId' | 'triggerRef'>;

export const SaveProgressModal = ({
  modalType = SaveProgressModalTypes.DEFAULT,
  onClickPrimaryCta,
  onClickSecondaryCta,

  /** ModalV2Props */
  onClose,
  rootId,
}: SaveProgressModalProps): JSX.Element => {
  return (
    <ModalV2
      dialogHeadingId="save-progress-title"
      lockBgScrolling
      onClose={onClose}
      rootId={rootId}
      triggerRef={null}
    >
      <div className={styles.modalContent}>
        <H.Title1 className={styles.modalHed} id="save-progress-title" presentation="h3">
          Don&apos;t lose your progress!
        </H.Title1>
        <P.BodyBase className={styles.modalDek}>{COPIES[modalType].dek}</P.BodyBase>
        <div className={styles.modalCtaWrapper}>
          <ButtonV3
            className={styles.modalCta}
            mobileSize="large"
            onClick={onClickSecondaryCta}
            variant={COPIES[modalType].secondaryCtaVariant}
          >
            {COPIES[modalType].secondaryCta}
          </ButtonV3>
          <ButtonV3 className={styles.modalCta} mobileSize="large" onClick={onClickPrimaryCta}>
            Save my draft
          </ButtonV3>
        </div>
      </div>
    </ModalV2>
  );
};
